/** Motivos de cese / baja laboral (PLAME / RR.HH.) */
export const MOTIVOS_CESE = [
  'Renuncia voluntaria',
  'Despido',
  'Fin de contrato',
  'Jubilación',
  'Fallecimiento',
  'Abandono de trabajo',
  'No se presentó a laborar',
  'Otros',
];

export const MOTIVO_CESE_OTROS = 'Otros';

export const motivoCeseEnLista = (valor) =>
  !valor || MOTIVOS_CESE.includes(valor) ? valor : MOTIVO_CESE_OTROS;

export const construirMotivoCese = (motivo, detalle = '') => {
  if (motivo !== MOTIVO_CESE_OTROS) return motivo;
  const texto = String(detalle || '').trim();
  return texto ? `${MOTIVO_CESE_OTROS}: ${texto}` : MOTIVO_CESE_OTROS;
};
